import { render, staticRenderFns } from "./MobileRecordCard.vue?vue&type=template&id=310fe0fe&scoped=true"
import script from "./MobileRecordCard.vue?vue&type=script&lang=js"
export * from "./MobileRecordCard.vue?vue&type=script&lang=js"
import style0 from "./MobileRecordCard.vue?vue&type=style&index=0&id=310fe0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fe0fe",
  null
  
)

export default component.exports